import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, SelectAnchorGarmentTrackingEvent, TrackingEventName } from "./tracking";

interface TrackSelectAnchorGarmentFunctionArgs {
  readonly id: string;
}

interface TrackSelectAnchorGarmentFunction {
  (args: TrackSelectAnchorGarmentFunctionArgs): void;
}

interface UseTrackSelectAnchorGarmentFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackSelectAnchorGarmentFunction {
  (agrs: UseTrackSelectAnchorGarmentFunctionArgs): TrackSelectAnchorGarmentFunction;
}

const useTrackSelectAnchorGarment: UseTrackSelectAnchorGarmentFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<SelectAnchorGarmentTrackingEvent>();

  const trackSelectAnchorGarment: TrackSelectAnchorGarmentFunction = useCallback(
    ({ id }) => {
      emitUserEvent({
        event: TrackingEventName.SELECT_ANCHOR_GARMENT,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        id,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackSelectAnchorGarment;
};

export { useTrackSelectAnchorGarment };
